import React from "react";
import {getTranslator} from "../../../translate";
import {URL} from "../ui/link";

const translator = getTranslator('page/travianServerListInfo');

export default function TravianUpdaterInfo() {
    return <>
        <URL href={'/travian/serverList'} className={'mb-2'}>{translator('back')}</URL>

        <h4 className={'mt-2'}>{translator('updaterHeadline')}</h4>
        <div dangerouslySetInnerHTML={{__html: translator('updaterInfo')}} />

        <h4 className={'mt-2'}>{translator('discoverHeadline')}</h4>
        <div dangerouslySetInnerHTML={{__html: translator('discoverInfo')}} />
    </>
}
